module.exports = __webpack_public_path__ + "static/media/Earned-Positions-Chicargos.1a479944.pdf";